<template>
    <div class="slide">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="1"
                    :total="3" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "trivia-2",
            currentTrivia: 1,
            questions: {
                question: {
                    "title": "What is the ORC department at THD responsible for?",
                    "answers": [
                        {"key": "A", "answer": "Tracking down repeat shoplifters"},
                        {"key": "B", "answer": "Investigating organized theft operations/groups"},
                        {"key": "C", "answer": "Arresting boosters"},
                        {"key": "D", "answer": "Researching loss prevention"}
                    ],
                    "correctAnswer": ["B"]
                }
            }
        }
    },
    mounted() {
        window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
    }
}
</script>

<style lang="scss" scoped>

</style>
